(function () {
  // Renvoie la contenance de la variante en litres ("125 mL" -> 0.125, "2,5 L" -> 2.5)
  function extractFormat(title) {
    if (!title) return null;
    var match = title.match(/([\d]+(?:[.,][\d]+)?)\s*(ml|cl|l)\b/i);
    if (!match) return null;
    var value = parseFloat(match[1].replace(',', '.'));
    if (!value) return null;
    var unit = match[2].toLowerCase();
    if (unit === 'ml') return value / 1000;
    if (unit === 'cl') return value / 100;
    return value;
  }

  function updateContenance(container, formatOverride) {
    var yieldVal = parseFloat(container.getAttribute('data-yield'));
    var layers = parseFloat(container.getAttribute('data-layers'));
    var format = formatOverride != null ? formatOverride : extractFormat(container.getAttribute('data-format'));
    if (!yieldVal || !format || !layers) {
      container.style.display = 'none';
      return;
    }
    container.style.display = '';
    var result = Math.ceil((yieldVal * format) / layers);
    container.querySelector('[data-contenance-value]').textContent = result;
  }

  // Initial calculation on load
  document.querySelectorAll('.liberon-contenance').forEach(function (el) {
    updateContenance(el);
  });

  // Listen for variant changes (FoxTheme dispatches "variant:changed" on document)
  document.addEventListener('variant:changed', function (e) {
    var variant = e.detail && e.detail.variant;
    if (!variant || !variant.title) return;
    var format = extractFormat(variant.title);
    document.querySelectorAll('.liberon-contenance').forEach(function (el) {
      el.setAttribute('data-format', variant.title);
      if (format == null) {
        el.style.display = 'none';
      } else {
        el.style.display = '';
        updateContenance(el, format);
      }
    });
  });
})();
